// Core
import { 
  Route, 
  Switch, 
  Redirect, 
  useRouteMatch, 
} from 'react-router-dom';

// Chakra imports
import { 
  Box,
} from '@chakra-ui/react';

// Components
import Partner from './Partner';
import PartnersEdit from './PartnersEdit';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

function Partners(props) {
  const { path } = useRouteMatch();

  const isPartners = usePermissionStatusByKey('GET:/admin/partners');
  const isCreatePartners = usePermissionStatusByKey('POST:/admin/partners');

  return (
    <>
      <Box>
        <Switch>
          <Route path={`${path}/:id(new|\\d+)`} render={() => <PartnersEdit/>}/>
          {(isPartners || isCreatePartners) && (
              <Route path={`${path}`} render={() => <Partner/>}/>
          )}
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default Partners;